module.exports = __webpack_public_path__ + "media/components/assets/sanlim_01-22c3f0335be92c784b3e940108d23cdb.jpg";